import React, { useEffect } from 'react';
import { createStyles, makeStyles } from '@mui/styles';
import { Accordion, Grid, Typography, AccordionDetails, CardContent, Theme, AccordionSummary } from '@mui/material';
import { Card } from '@mui/material';
import LanguageUtils from '../../utils/LanguageUtils';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { fetchResponsibilityCenterById } from '../../reducers/responsibilityCenterReducer';
import ResponsibilityCenter from '../../interfaces/output/responsibilityCenter';

interface IViewResponsibilityCenterProps {
    classes?: any;
    theme?: Theme;
    responsibilityCenter: ResponsibilityCenter;
}

const styles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex'
        },
        content: {
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto'
        },
        cardContent: {
            flex: 1,
            '& .MuiAccordionSummary-content.Mui-expanded': {
                margin: '10px'
            },
            '&  .MuiAccordionSummary-root.Mui-expanded': {
                minHeight: 'inherit'
            }
        },
        container: {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4)

        },
        heading: {
            fontSize: theme.typography.pxToRem(15),
            fontWeight: theme.typography.fontWeightRegular
        },
        accordion: {
            backgroundColor: 'rgba(0, 0, 0, .03)',
            marginTop: '10px'
        },
        gridItem: {
            marginBottom: theme.spacing(1)
        },
        typography: {
            marginLeft: theme.spacing(5)
        }
    })
);

const messages = {
    details: LanguageUtils.createMessage('Responsibility center details'),
    name: LanguageUtils.createMessage('Name'),
    code: LanguageUtils.createMessage('code')
};

export default function ViewResponsabiliyCenter(props: IViewResponsibilityCenterProps): JSX.Element {
    const classes = styles();
    const { responsibilityCenter } = props;
    const dispatch = useDispatch();
    //const propsIsLoadingTerminal = useSelector(isLoadingTerminal);
    // const isLoadingObjects = [useSelector(isLoadingResponsibilityCenter)];
    // const isLoading = isLoadingObjects.find((obj: boolean) => obj === true);

    useEffect(() => {
        if(responsibilityCenter.id) {
            dispatch(fetchResponsibilityCenterById(responsibilityCenter.id));
        }
    }, [responsibilityCenter.id]);

    return (<Grid container alignItems="flex-start">
        <Grid item md={12}>
            <Card className={classes.root} >
                <CardContent className={classes.cardContent}>
                    <Accordion expanded>
                        <AccordionSummary expandIcon={<span />}
                            aria-controls="panel1a-content" id="panel1a-header" className={classes.accordion}
                        >
                            <Typography className={classes.heading}><FormattedMessage {...messages.details} /></Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container>
                                <Grid item xs={4} className={classes.gridItem}>
                                    <Typography gutterBottom><FormattedMessage {...messages.name} />: </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography gutterBottom>{responsibilityCenter.name || '-'}</Typography>
                                </Grid>
                                <Grid item xs={4} className={classes.gridItem}>
                                    <Typography gutterBottom><FormattedMessage {...messages.code} />: </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography gutterBottom>{responsibilityCenter.code || '-'}</Typography>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </CardContent>
            </Card>
        </Grid>
    </Grid>
    );
}